import React, { useEffect } from "react";

type ToastProps = {
  message: string;
  type: "success" | "error" | "info" | "warning" | "loading";
  duration: number;
  onClose: () => void;
};

const Toast: React.FC<ToastProps> = ({ message, type, duration, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(onClose, duration);
    return () => clearTimeout(timer);
  }, [duration, onClose]);

  const getBackgroundColor = () => {
    switch (type) {
      case "success":
        return "#4caf50";
      case "error":
        return "#f44336";
      case "info":
        return "#2196f3";
      case "warning":
        return "#ff9800";
      case "loading":
        return "#555";
      default:
        return "#2196f3";
    }
  };

  return (
    <div style={{ ...styles.toast, backgroundColor: getBackgroundColor() }}>
      <span>{message}</span>
    </div>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
  toast: {
    padding: "12px 16px",
    borderRadius: "8px",
    color: "#fff",
    fontSize: "14px",
    fontWeight: "bold",
    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
    maxWidth: "300px",
    transition: "opacity 0.3s ease, transform 0.3s ease",
  },
};

export default Toast;
